import React from 'react';
import PricingCard from '../PricingCard/PricingCard';
import { CardsGrid, Title } from './PricingGrid.styles';

const PricingGrid = ({ mainTitle, cards }) => {
  return (
    <div>
      {mainTitle && <Title>{mainTitle}</Title>}

      {cards && (
        <CardsGrid>
          {cards.map(card => (
            <PricingCard
              key={card.id}
              title={card.title}
              text={card.text}
              price={card.price}
              priceLabel={card.priceLabel}
              ctaText={card.linkTitle}
              ctaUrl={card.ctaUrl}
            />
          ))}
        </CardsGrid>
      )}
    </div>
  );
};

export default PricingGrid;
